import { Box, LinearProgress, Typography } from '@mui/material';
import FileThumbnail from 'components/@home/@messages/ChatPanel/MessagesList/MessageGroup/FileThumbnail';
import moment from 'moment';
import { bool, number, object } from 'prop-types';
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useRef, useState } from 'react';
import PlayButton from './PlayButton';

const AudioThumbnail = ({ data, right = false, minWidth = 100 }) => {
  const audio = useRef();
  const [loaded, setLoaded] = useState(false);
  const [paused, setPaused] = useState(true);
  const [duration, setDuration] = useState(null);
  const [progress, setProgress] = useState(0);
  const [buffer, setBuffer] = useState(0);
  const [error, setError] = useState(null);

  const handleBuffer = e => {
    const elapsedTime = e.target.buffered.end(e.target.buffered.length - 1);
    const result = (elapsedTime / e.target.duration) * 100;
    setBuffer(result);
  };

  const handleProgress = e => {
    const elapsedTime = e.target.currentTime;
    const result = (elapsedTime / e.target.duration) * 100;
    setProgress(result);
    setDuration(elapsedTime);

    handleBuffer(e);
  };

  const handleMetadata = e => {
    setDuration(e.target.duration === Infinity ? 0 : e.target.duration);
  };

  const handleEnded = () => {
    setPaused(true);
  };

  const handleLoaded = () => {
    setLoaded(true);
    setError(null);
  };

  const play = () => audio.current.play();

  const pause = () => {
    audio.current.pause();
    setPaused(true);
  };

  useEffect(() => {
    if (paused) {
      pause();
    } else {
      play();
    }
  }, [paused]);

  const togglePlay = async () => {
    if (!loaded) {
      return;
    }
    setPaused(p => !p);
  };

  if (error) {
    return <FileThumbnail key={data._id} data={data} right={right} />;
  }

  return (
    <Box sx={{ minWidth, maxWidth: 250, flexGrow: 1 }}>
      <audio
        onTimeUpdate={handleProgress}
        onLoadedMetadata={handleMetadata}
        onLoadedData={handleLoaded}
        onEnded={handleEnded}
        onError={setError}
        ref={audio}
        src={data.httpLink}
        type={data.mimeType}
      >
        Your browser does not support the html5 audio.
      </audio>
      <Box
        sx={{
          p: 1.25,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            alignItems: 'center',
            display: 'flex',
          }}
        >
          <LinearProgress
            sx={{ flexGrow: 1, borderRadius: '10px' }}
            variant={paused ? 'determinate' : 'buffer'}
            value={progress}
            valueBuffer={buffer}
          />
          <Typography
            variant="caption"
            sx={{
              pl: 1.25,
              pr: 0.625,
              fontSize: 14,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {moment.utc(moment.duration(duration, 's').asMilliseconds()).format('mm:ss')}
          </Typography>
        </Box>
        <PlayButton right={right} paused={paused} loaded={loaded} onClick={togglePlay} />
      </Box>
    </Box>
  );
};

AudioThumbnail.propTypes = {
  right: bool,
  data: object.isRequired,
  minWidth: number,
};

export default AudioThumbnail;
